module.exports = __webpack_public_path__ + "img/openpbb2024-2.2b81dff0.png";